import type React from "react";

import { ConfirmationModal, type ConfirmationModalProps } from "../confirmation-modal";

export interface FormModalProps extends Omit<ConfirmationModalProps, "onSubmit" | "onConfirm" | "confirmText"> {
	readonly onSubmit: (e: React.FormEvent) => void | Promise<void>;
	readonly submitText: string;
}

export const FormModal: React.FC<FormModalProps> = ({ children, onSubmit, submitText, slotProps, ...props }) => {
	return (
		<ConfirmationModal
			{...props}
			confirmText={submitText}
			onConfirm={() => undefined}
			slotProps={{
				...slotProps,
				modalContainer: {
					component: "form",
					onSubmit,
					...slotProps?.modalContainer,
				},
				confirmButton: {
					type: "submit",
					onClick: undefined,
					...slotProps?.confirmButton,
				},
			}}
		>
			{children}
		</ConfirmationModal>
	);
};
